// /Users/stuartmcgeer/portalworx/frontend/src/App.tsx

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Layout from './layouts/layout';
import { PermissionProvider } from './contexts/PermissionContext';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import Dashboard from './pages/Dashboard/Dashboard';

const Login = lazy(() => import('./pages/Login/Login'));
const AdminView = lazy(() => import('./pages/Admin/AdminView'));
const UserForm = lazy(() => import('./forms/UserForm'));
const Logout = lazy(() => import('./pages/Logout/Logout'));
const Profile = lazy(() => import('./pages/Profile/Profile'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));
const ProjectView = lazy(() => import('./pages/Projects/ProjectView'));
const ProjectForm = lazy(() => import('./forms/ProjectForm'));
const ProjectDetail = lazy(() => import('./pages/ProjectDetail/ProjectDetail'));
const DirectMessage = lazy(() => import('./pages/DirectMessage/DirectMessage'));
const Notifications = lazy(() => import('./pages/Notifications/Notifications'));
const Settings = lazy(() => import('./pages/Settings/Settings'));

const App: React.FC = () => {
  return (
    <AuthProvider>
      <PermissionProvider>
        <SettingsProvider>
          <WebSocketProvider>
            <Router>
              <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                  <Route path="/" element={<Navigate to="/login" />} />
                  <Route path="/login" element={<Login />} />
                  <Route element={<Layout />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/admin" element={<AdminView />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/user-form" element={<UserForm />} />
                    <Route path="/projects" element={<ProjectView />} />
                    <Route path="/project-form" element={<ProjectForm />} />
                    <Route path="/projects/:id" element={<ProjectDetail />} />
                    <Route path="/direct-message" element={<DirectMessage />} />
                    <Route path="/notifications" element={<Notifications />} />
                    <Route path="/settings" element={<Settings />} />
                  </Route>
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </Router>
          </WebSocketProvider>
        </SettingsProvider>
      </PermissionProvider>
    </AuthProvider>
  );
};

export default App;

